import React, { useEffect, useMemo, useState } from "react";
import PopupHeader from "../PopupHeader/PopupHeader";
import { TextField, Stack, DefaultButton, PrimaryButton, Dropdown } from "@fluentui/react";
import { localize } from "src/utils/l10n";
import FormControl from "../FormControl/FormControl";
import FormSection from "../FormSection/FormSection";
import { connect, useDispatch } from "react-redux";
import { IApplicationState } from "src/reducer";
import UnstyledButton from "../UnstyledButton/UnstyledButton";
import Label from "../Label/Label";
import Visage2Icon from "../Visage2Icon/Visage2Icon";
import api from "src/api/SpintrApi";
import { setQuestionAlternativeCollections } from "src/actions/instance";
import { AxiosResponse } from "axios";

interface IProps {
    questionAlternativeCollection: any;
    onDone: () => void;
}

interface IState {
    isLoading: boolean;
    questionAlternativeCollection: any;
}

const QuestionAlternativeCollectionForm = (props: IProps) => {
    const dispatch = useDispatch();

    const [state, setState] = useState<IState>({
        isLoading: false,
        questionAlternativeCollection: props.questionAlternativeCollection,
    });

    const originalStrings = useMemo(() => {
        return [
            localize("STRONGLY_AGREE"),
            localize("AGREE"),
            localize("NEITHER_AGREE_DISAGREE"),
            localize("DISAGREE"),
            localize("STRONGLY_DISAGREE"),
        ];
    }, []);

    const save = () => {
        setState((s: IState) => ({
            ...s,
            isLoading: true
        }));

        api.post("/api/v1/surveys/question-alternative-collections", state.questionAlternativeCollection).then(() => {
            api.get("/api/v1/surveys/question-alternative-collections").then((response: AxiosResponse) => {
                dispatch(setQuestionAlternativeCollections(response.data));
                props.onDone();
            }).catch(() => {});
        }).catch(() => {
            setState((s: IState) => ({
                ...s,
                isLoading: false
            }));
        });
    }

    return (
        <div className="QuestionAlternativeCollectionForm">
            <PopupHeader
                text={state.questionAlternativeCollection.isNew ?
                    localize("ADD_ANSWER_ALTERNATIVE_COLLECTION") :
                    localize("EDIT_ANSWER_ALTERNATIVE_COLLECTION")}
                hideCloseButton />
            <FormSection>
                <FormControl>
                    <Label size="body-2" color="p-mid-grey-5" className="no-questions">{localize("ANSWER_ALTERNATIVES_DESCRIPTION")}</Label>
                </FormControl>
                <FormControl>
                    <TextField
                        value={state.questionAlternativeCollection.text}
                        className="textField"
                        label={localize("Namn")}
                        resizable={false}
                        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newValue?: string) => {
                            setState((s: IState) => ({
                                ...s,
                                questionAlternativeCollection: {
                                    ...s.questionAlternativeCollection,
                                    text: newValue
                                }
                            }));
                        }}
                        required
                        aria-required
                        validateOnFocusOut
                        validateOnLoad={false}
                        autoFocus
                    />
                </FormControl>
                {state.questionAlternativeCollection.alternatives.map((a: any, index: number) => {
                    return (
                        <FormControl key={index}>
                            <TextField
                                value={a.text}
                                className="textField"
                                label={localize("OPTION") + " " + (index + 1)}
                                resizable={false}
                                placeholder={originalStrings[index]}
                                onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newValue?: string) => {
                                    setState((s: IState) => ({
                                        ...s,
                                        questionAlternativeCollection: {
                                            ...s.questionAlternativeCollection,
                                            alternatives: s.questionAlternativeCollection.alternatives.map((alternative: any, alternativeIndex: number) => {
                                                if (alternativeIndex === index) {
                                                    return {
                                                        ...alternative,
                                                        text: newValue
                                                    }
                                                }

                                                return alternative;
                                            })
                                        }
                                    }));
                                }}
                                required
                                aria-required
                                validateOnFocusOut
                                validateOnLoad={false}
                                autoFocus
                            />
                        </FormControl>
                    )
                })}
            </FormSection>
            <Stack className="bottom-buttons" horizontal={true} horizontalAlign="end" tokens={{ childrenGap: 20 }}>
                <DefaultButton
                    onClick={props.onDone}
                    text={localize("GO_BACK")} />
                <PrimaryButton
                    onClick={save}
                    text={localize("SAVE")} />
            </Stack>
        </div>
    )
}

const mapStateToProps = (state: IApplicationState, props: IProps) => ({
    ...props,
    questionAlternativeCollections: state.instance.questionAlternativeCollections
});

export default connect(mapStateToProps)(QuestionAlternativeCollectionForm);
